import { createContext, useState, useContext } from 'react';
import translations from '../utils/translations';

const ProductLanguageContext = createContext();

export const ProductLanguageProvider = ({ children }) => {
  const [productLanguage, setProductLanguage] = useState('English'); // default language

  const t = (key) => {
    return translations[key] && translations[key][productLanguage] ? translations[key][productLanguage] : key;
  };

  return (
    <ProductLanguageContext.Provider value={{ productLanguage, setProductLanguage, t }}>
      {children}
    </ProductLanguageContext.Provider>
  );
};

export const useProductLanguage = () => useContext(ProductLanguageContext);
